import { useEffect } from "react";
import PageHeader from "../components/PageHeader";
import SectionTitle from "../components/SectionTitle";
import CTASection from "../components/CTASection";
import { amenitiesData } from "../data/amenitiesData";
import "../styles/Pages.css";

const Amenities = () => {
  useEffect(() => { document.title = "Amenities | USHA Resort, Patna"; }, []);

  return (
    <>
      <PageHeader
        title="Resort Amenities"
        subtitle="Home · Amenities"
        image="/images/aboutus/Amenities_header.png"
      />

      <section className="amenities-section">
        <div className="container">
          <SectionTitle
            tag="World-Class Facilities"
            title="Everything You Need, All in One Place"
            subtitle="From relaxation to celebration — USHA Resort is equipped for every occasion."
          />
          <div className="amenities-grid gap-top">
            {amenitiesData.map(({ icon: Icon, title, desc }) => (
              <div className="amenity-card" key={title}>
                <div className="amenity-icon"><Icon /></div>
                <h3>{title}</h3>
                <p>{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
};

export default Amenities;